import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '@/lib/api';
import StoryCarousel from '@/components/StoryCarousel';
import CourseFeed from '@/components/CourseFeed';
import BadgeJourneyCard from '@/components/BadgeJourneyCard';
import { useCourseLang } from '@/lib/courseLang';
import { Play } from 'lucide-react';

export default function TraineeDashboard() {
    const [courses, setCourses] = useState(null);
    const [lang] = useCourseLang();
    useEffect(() => {
        setCourses(null);
        api.get(`/trainee/course-catalog?language=${encodeURIComponent(lang)}`).then((r) => setCourses(r.data || [])).catch(() => setCourses([]));
    }, [lang]);

    if (!courses) return <div className="py-12 text-center text-white/60" data-testid="trainee-loading">Loading…</div>;

    // Resume = the most recently started course that is not yet completed.
    const started = courses
        .filter((c) => c.started && !c.completed)
        .sort((a, b) => (b.last_activity_at || '').localeCompare(a.last_activity_at || ''));
    const resume = started[0] || courses.find((c) => !c.completed) || null;
    const isResuming = !!started[0];

    return (
        <div data-testid="trainee-dashboard-page" className="space-y-5">
            <StoryCarousel />

            {/* Badge journey loyalty card */}
            <BadgeJourneyCard />

            {/* Continue banner */}
            {resume && (
                <Link to={`/learn/courses/${resume.id}`} data-testid="continue-learning-banner"
                    className="relative block rounded-2xl p-5 overflow-hidden shadow-[0_8px_32px_rgba(1,48,34,0.35)] group max-w-xl mx-auto bg-gradient-to-br from-[#02160E] via-[#013022] to-[#02160E]">
                    <div className="relative z-10 flex justify-between items-center gap-4">
                        <div className="flex flex-col gap-1 max-w-[72%]">
                            <span className="text-brand-yellow/80 text-[11px] font-bold uppercase tracking-wider">{isResuming ? 'Pick up where you left off' : 'Start your next course'}</span>
                            <span className="text-white text-base sm:text-lg font-bold leading-tight line-clamp-2">{resume.title}</span>
                            {resume.progress_percent > 0 && (
                                <div className="mt-1.5 h-1.5 w-40 max-w-full bg-white/15 rounded-full overflow-hidden">
                                    <div className="h-full bg-brand-yellow" style={{ width: `${resume.progress_percent}%` }} />
                                </div>
                            )}
                        </div>
                        <div className="w-12 h-12 rounded-full bg-brand-yellow flex items-center justify-center text-brand-black shadow-[0_0_15px_rgba(0,219,121,0.5)] group-hover:scale-105 transition-transform">
                            <Play className="h-5 w-5 fill-current ml-0.5" />
                        </div>
                    </div>
                </Link>
            )}

            {/* Social course feed (endless scroll) */}
            <CourseFeed initialCourses={courses} />
        </div>
    );
}
